import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef, output, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

/**
 * Responsible for rendering an selected item on a list
 */
@Component({
    selector: 'unified-ui-selected-info-item',
    standalone: true,
    imports: [NgTemplateOutlet, ButtonModule, RippleModule, TooltipModule],
    templateUrl: './selected-info-item.component.html',
    styleUrl: './selected-info-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedInfoItemComponent {
    /**
     * Input template of augmented content
     */
    public readonly augmentedContentTemplateRef = input<TemplateRef<any>>();
    /**
     * Input template of main content
     */
    public readonly contentTemplateRef = input<TemplateRef<any>>();
    /**
     * If it has a edit button
     */
    public readonly editButton = input<boolean | undefined>(false);
    /**
     * Edit button tooltip
     */
    public readonly editButtonToolTip = input<string>();
    /**
     * Item data to display
     */
    public readonly item = input.required<{ id: string; name: string; }>();
    /**
     * Input template of preceding action
     */
    public readonly precedingContentTemplateRef = input<TemplateRef<any>>();
    /**
     * Output for emitting delete button click
     */
    public readonly delete = output<string>();
    /**
     * Output for emitting edit button click
     */
    public readonly edit = output<string>();
}
